import React, { useState } from 'react';
import styles from './styles.module.css';
import { IFertilizerOctoberResponse } from '../api/types';
import LeasingSelectYear from '../../../mechanization/leasing/Leasingselect';

interface DinamicByRegionsOctoberProps {
  fertilizercropsAllData?: IFertilizerOctoberResponse;
  selectedYear: number | null;
  onYearChange: (year: number | null) => void;
}

interface TooltipState {
  x: number;
  y: number;
  region: string;
  values: {
    necessary: number;
    brought: number;
  };
}

export const DinamicByRegionsOctober: React.FC<DinamicByRegionsOctoberProps> = ({ 
  fertilizercropsAllData,
  selectedYear,
  onYearChange
}) => {
  const [tooltip, setTooltip] = useState<TooltipState | null>(null);

  if (!fertilizercropsAllData?.res) {
    return null;
  }

  const regions = fertilizercropsAllData.res;

  const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>, region: string) => {
    const regionData = regions.find(r => r.territorialUnitRegion === region);
    if (!regionData || !regionData.districts[0]) return;

    setTooltip({
      x: e.clientX,
      y: e.clientY,
      region,
      values: {
        necessary: regionData.districts[0].necessary,
        brought: regionData.districts[0].brought
      }
    });
  };

  const handleMouseLeave = () => {
    setTooltip(null);
  };

  const maxValues = regions.reduce((acc, region) => {
    const district = region.districts[0];
    if (!district) return acc;
    return {
      necessary: Math.max(acc.necessary, district.necessary),
      brought: Math.max(acc.brought, district.brought)
    };
  }, { necessary: 0, brought: 0 });

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>Диаграмма необходимых и внесенных удобрений по регионам</h2>
        <div className={styles.yearSelect}>
          <LeasingSelectYear value={selectedYear} onChange={onYearChange} />
        </div>
      </div>
      <div className={styles.chart}>
        {regions.map((region) => {
          const district = region.districts[0];
          if (!district) return null;

          return (
            <div
              key={region.territorialUnitRegion}
              className={styles.region}
              onMouseEnter={(e) => handleMouseEnter(e, region.territorialUnitRegion)}
              onMouseLeave={handleMouseLeave}
            >
              <div className={styles.bars}>
                <div
                  className={styles.bar}
                  style={{
                    height: `${(district.necessary / maxValues.necessary) * 100}%`,
                    backgroundColor: '#4D8E21'
                  }}
                />
                <div
                  className={styles.bar}
                  style={{
                    height: `${(district.brought / maxValues.brought) * 100}%`,
                    backgroundColor: '#B6D434'
                  }}
                />
              </div>
              <div className={styles.regionName}>
                {region.territorialUnitRegion.replace(' область', '')}
              </div>
            </div>
          );
        })}
      </div>

      <div className={styles.legend}>
        <div className={styles.legendItem}>
          <div className={styles.legendColor} style={{ backgroundColor: '#4D8E21' }} />
          <span>Необходимо</span>
        </div>
        <div className={styles.legendItem}>
          <div className={styles.legendColor} style={{ backgroundColor: '#B6D434' }} />
          <span>Внесено</span>
        </div>
      </div>

      {tooltip && (
        <div
          className={styles.tooltip}
          style={{
            left: tooltip.x,
            top: tooltip.y
          }}
        >
          <h3>{tooltip.region}</h3>
          <p>Необходимо: {tooltip.values.necessary}</p>
          <p>Внесено: {tooltip.values.brought}</p>
        </div>
      )}
    </div>
  );
};